import { savePreferences } from '../api/preferences';
import { DOM_IDS, HS_EVENT_CODE } from '../utils/constants';
import { getPathSuffix } from '../utils/url';
import { PATH_SUFFIX } from '../api/endpoints';
function getClickEventCode(subscriptionForm) {
  try {
    const formPayload = new FormData(subscriptionForm);
    const pathSuffix = getPathSuffix();
    let hsEventCode = HS_EVENT_CODE.MANAGE_PREFERENCES;
    if (pathSuffix === PATH_SUFFIX.SINGLE) {
      hsEventCode = HS_EVENT_CODE.UNSUBSCRIBE_SINGLE;
    } else if (formPayload.get('globalunsub')) {
      hsEventCode = HS_EVENT_CODE.UNSUBSCRIBE_ALL;
    }
    return hsEventCode;
  } catch (_unused) {
    return HS_EVENT_CODE.UNKNOWN;
  }
}
function savePreferencesWorker(subscriptionForm) {
  return function (event) {
    event.preventDefault();
    const formPayload = new FormData(subscriptionForm);
    const hsEventCode = getClickEventCode(subscriptionForm);
    savePreferences(formPayload, {
      hsEventCode
    });
  };
}
export default function manageFormSubmission() {
  const subscriptionForm = document.getElementById(DOM_IDS.subscriptionForm);
  if (subscriptionForm) {
    const savePreferencesCallback = savePreferencesWorker(subscriptionForm);
    subscriptionForm.addEventListener('submit', savePreferencesCallback);
  }
}